import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Users, ScrollText, FileText, Building2, Clock } from 'lucide-react'
import UsersTab from '@/pages/SuperAdmin/UsersTab'
import AuditTab from '@/pages/SuperAdmin/AuditTab'

type TabKey = 'users' | 'audit' | 'kostenuebernahmen' | 'firmen-ohne-admin' | 'approval-overdue'

interface TabDef {
  key: TabKey
  label: string
  icon: typeof Users
  /** Wenn gesetzt: Klick navigiert auf diese Route statt Inline-Inhalt zu rendern. */
  navigateTo?: string
}

const TABS: TabDef[] = [
  { key: 'users', label: 'Benutzer', icon: Users },
  { key: 'audit', label: 'Audit', icon: ScrollText },
  { key: 'kostenuebernahmen', label: 'Zuzahler-Erklärungen', icon: FileText, navigateTo: '/superadmin/kostenuebernahmen' },
  { key: 'firmen-ohne-admin', label: 'Firmen ohne Admin', icon: Building2, navigateTo: '/superadmin/kostenuebernahmen/firmen-ohne-admin' },
  { key: 'approval-overdue', label: 'Approval überfällig', icon: Clock, navigateTo: '/superadmin/kostenuebernahmen/admin-approval-overdue' },
]

export default function SuperAdminPage() {
  const [tab, setTab] = useState<TabKey>('users')
  const navigate = useNavigate()

  return (
    <div className="max-w-7xl mx-auto px-6 py-8">
      <header className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Superadmin-Cockpit</h1>
        <p className="text-sm text-gray-500 mt-1">
          Benutzer, Audit-Log, Kostenübernahmeerklärungen.
        </p>
      </header>

      <nav className="flex border-b border-gray-200 mb-6" aria-label="Tabs">
        {TABS.map((t) => {
          const Icon = t.icon
          const active = tab === t.key
          return (
            <button
              key={t.key}
              onClick={() => (t.navigateTo ? navigate(t.navigateTo) : setTab(t.key))}
              className={`flex items-center gap-2 px-5 py-3 text-sm font-semibold border-b-2 -mb-[2px] transition-colors ${
                active
                  ? 'border-fom-500 text-fom-700'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <Icon size={16} />
              {t.label}
            </button>
          )
        })}
      </nav>

      <section>
        {tab === 'users' && <UsersTab />}
        {tab === 'audit' && <AuditTab />}
      </section>
    </div>
  )
}
